export default __webpack_public_path__ + "static/media/debit.78a02465.svg";